// Videos year picker — desktop opens on hover (pure CSS). On touch, tapping
// the "year ▼" header toggles an `.is-open` class; tapping outside or pressing
// Escape closes it. Picking a year navigates, so no explicit close is needed.

const videosYearPicker = {
    init() {
        document.querySelectorAll('[data-videos-picker]').forEach((root) => {
            const head = root.querySelector('.vp__head')
            if (!head) return

            const isOpen = () => root.classList.contains('is-open')
            const open   = () => root.classList.add('is-open')
            const close  = () => {
                root.classList.remove('is-open')
                // Drop focus too, or :focus-within would hold the panel open
                // on touch even after the class is removed.
                if (root.contains(document.activeElement)) document.activeElement.blur()
            }

            // Tap the year header (the "2025 ▼" row + caret sit here) to
            // toggle. The caret is pointer-events:none, so its taps land here.
            head.addEventListener('click', (e) => {
                e.stopPropagation()
                isOpen() ? close() : open()
            })

            // Tap anywhere outside closes. pointerdown (not click) so it also
            // fires for taps on inert page areas on iOS.
            document.addEventListener('pointerdown', (e) => {
                if (isOpen() && !root.contains(e.target)) close()
            })

            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && isOpen()) close()
            })
        })
    },
}

export default videosYearPicker
